import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import axios from "axios";
import { API } from "../context/AuthContext";
import { CheckCircle2 } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const fmt = (n, language) => new Intl.NumberFormat(language === "en" ? "en-IE" : "it-IT", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(n || 0);

export default function PaymentSuccess() {
  const { language, t } = useLanguage();
  const [params] = useSearchParams();
  const sid = params.get("session_id");
  const [status, setStatus] = useState(null);
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!sid) return;
    if (status?.payment_status === "paid" || tries > 12) return;
    const t = setTimeout(async () => {
      try {
        const { data } = await axios.get(`${API}/payments/status/${sid}`);
        setStatus(data);
      } catch {}
      setTries(x => x + 1);
    }, 1800);
    return () => clearTimeout(t);
  }, [sid, tries, status]);

  return (
    <div className="max-w-[900px] mx-auto px-6 py-24 text-center">
      <div className="text-[#8C3A3A] flex justify-center"><CheckCircle2 size={72} strokeWidth={1} /></div>
      <div className="overline text-stone-500 mt-6">{t("Grazie")}</div>
      <h1 className="font-serif text-5xl tracking-tighter mt-2">{t("Pagamento ricevuto.")}</h1>
      <p className="mt-4 text-stone-600">
        {status?.payment_status === "paid"
          ? `${t("Abbiamo confermato il tuo pagamento di ")}${fmt(status?.amount, language)}${t(". Ti abbiamo inviato una email con i dettagli di spedizione.")}`
          : t("Stiamo confermando il pagamento con Stripe… attendi qualche istante.")}
      </p>
      {status && <div className="mt-4 text-xs font-mono text-stone-500">Session: {sid}</div>}
      <div className="mt-10 flex gap-3 justify-center">
        <Link to="/dashboard" data-testid="success-dashboard-btn" className="text-xs uppercase tracking-widest font-semibold bg-stone-900 hover:bg-[#8C3A3A] text-stone-50 px-8 py-4 transition-colors">{t("Vai al dashboard")}</Link>
        <Link to="/browse" data-testid="success-browse-btn" className="text-xs uppercase tracking-widest font-semibold border border-stone-900 hover:bg-stone-900 hover:text-stone-50 px-8 py-4 transition-colors">{t("Altri lotti")}</Link>
      </div>
    </div>
  );
}
